import { toNumber } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import Backdrop from 'containers/BackdropContainer';
import AppSelector from 'state/selectors/app';
import CartSelector from 'state/selectors/cart';
import CollectionPageSelector from 'state/selectors/collection-page';
import TopNavigationSelector from 'state/selectors/top-navigation';
import { ITERABLE_EMAIL_ALLBIRDS_ID_QUERY_PARAM } from 'utils/Customer/constants';
import Log from 'utils/Log';
import { removeUrlParam } from 'utils/Url';

const AppController = class {
  static mountBackdropContainer = store => {
    ReactDOM.render(
      <Provider store={store}>
        <Backdrop />
      </Provider>,
      document.getElementById('backdrop-container')
    );
  };

  static shouldPageBeFrozen = store => {
    const state = store.getState();
    const l0ActiveNode = TopNavigationSelector.getActiveNodeAtDepth(state, 0);
    const isTopNavigationOpen = !!l0ActiveNode;
    const isModalOpen = AppSelector.modalIsOpen(state);
    const isCollectionPageFilterDrawerOpen = CollectionPageSelector.getIsFilterDrawerOpen(state);
    const isCartOpen = CartSelector.getIsCartOpen(state);
    return !!(isTopNavigationOpen || isModalOpen || isCollectionPageFilterDrawerOpen || isCartOpen);
  };

  static removeIterableEmailParam = () => {
    removeUrlParam(ITERABLE_EMAIL_ALLBIRDS_ID_QUERY_PARAM);
  };

  static subscribeFreezePageScroll = store => {
    let verticalScroll = 0;

    const freezePageScroll = () => {
      try {
        // To freeze page scroll, we want to set the body to fixed, and keep track of its scroll (because iOS)
        // To unfreeze page scroll, we want to un-fix its position, and reset the scroll to what it was previously
        // Source: https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/

        if (AppController.shouldPageBeFrozen(store)) {
          const pageIsScrollable = document.body.style.position !== 'fixed';
          // If page is scrollable and navigation is open, set its position to fixed
          if (pageIsScrollable) {
            verticalScroll = window.pageYOffset;
            document.body.style.top = `-${verticalScroll}px`;
            document.body.style.position = 'fixed';
          }
        } else {
          const pageIsFixed = document.body.style.position === 'fixed';
          // If page has fixed positioning and navigation is closed, make the page scrollable again
          if (pageIsFixed) {
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, toNumber(verticalScroll));
          }
        }
      } catch (e) {
        Log.error('Failed to freeze page scroll', e);
      }
    };

    freezePageScroll();
    store.subscribe(freezePageScroll);
  };

  static init = async store => {
    AppController.mountBackdropContainer(store);
    AppController.subscribeFreezePageScroll(store);
    AppController.removeIterableEmailParam();
  };
};

export default AppController;
